import { render, staticRenderFns } from "./main.vue?vue&type=template&id=96054790&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../nodejs_workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/pix/Documents/dev/wedia/wedia/war/nodejs_workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96054790')) {
      api.createRecord('96054790', component.options)
    } else {
      api.reload('96054790', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=96054790&", function () {
      api.rerender('96054790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/javascript/bov3/js/vue/components/wedia/wxm-chain-edit-carousel/src/main.vue"
export default component.exports